import LineGradient from "../components/LineGradient";
import { motion } from "framer-motion";
import ProjectsData from "../assets/data/projects";



const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const projectVariant = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1 },
};

const Project = ({ imgSrc, title, text, githubURL=""}) => {
  const overlayStyles = `absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500
    bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue inside-border`;
  const projectTitle = title.split(" ").join("-").toLowerCase();

  return (
    <motion.a href={githubURL} target="_blank"  variants={projectVariant} className="relative">
      <div className={overlayStyles}>
        <p className="text-2xl text-red font-playfair">{title}</p>
        <p className="mt-7">
          {text}
        </p>
      </div>
      <img className=" w-[400px] h-[350px]"src={imgSrc} alt={projectTitle} />
    </motion.a>
  );
};

const Projects = () => {
   const projects = ProjectsData;

  return (
    <section id="projects" className="pt-48 pb-48">
      {/* HEADINGS */}
      <motion.div
        className="md:w-2/5 mx-auto text-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, y: -50 },
          visible: { opacity: 1, y: 0 },
        }}
      >
        <div>
          <p className="font-playfair font-semibold text-4xl">
            <span className="text-red">PRO</span>JECTS
          </p>
          <div className="flex justify-center mt-5">
            <LineGradient width="w-2/3" />
          </div>
        </div>
        <p className="mt-10 mb-10">
          This section showcases some of my projects. I have worked on a variety
          of projects during my University but also in my free time. I am
          passionate about creating beautiful user interfaces and smooth user
          experiences.
        </p>
      </motion.div>

      {/* PROJECTS */}
      <div className="flex justify-center">
        <motion.div
          className="sm:grid sm:grid-cols-3"
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {/* ROW 1 */}
          <div
            className="flex justify-center text-center items-center p-10 bg-red
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold"
          >
            BEAUTIFUL USER INTERFACES
          </div>

          {ProjectsData.map((project) => (
            <Project
              imgSrc={project.imgsrc}
              title={project.title}
              text={project.text}
              githubURL={project.github_url}
            />
          ))}   
          
          <div
            className="flex justify-center text-center items-center p-10 bg-blue
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold"
          >
            SMOOTH USER EXPERIENCE
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Projects;